module.exports = __webpack_public_path__ + "img/slide11-piece-25.3e39484d.png";